import { Trans, useTranslation } from "react-i18next";
import {
  ListContaniner,
  PrivacyPolicyText,
  SectionContainer,
  SectionTitle,
  SubSectionContainer,
} from "../PrivacyPolicyContent.styled";

export const TransferPersonalDataSectionContent = (
  props: TransferPersonalDataSectionContentProps
) => {
  const { i18n } = useTranslation();

  return (
    <SectionContainer>
      <SectionTitle>
        <Trans i18nKey={"privacyPolicy.transferPersonalData.title"} />
      </SectionTitle>
      <SubSectionContainer>
        <ListContaniner>
          {(
            i18n.t("privacyPolicy.transferPersonalData.list", {
              returnObjects: true,
            }) as string[]
          ).map((definition, index) => (
            <PrivacyPolicyText>
              <Trans i18nKey={definition} />
            </PrivacyPolicyText>
          ))}
        </ListContaniner>
      </SubSectionContainer>
    </SectionContainer>
  );
};

export interface TransferPersonalDataSectionContentProps {}
